import statechange from './reducers/index'
import {createStore} from 'redux';

let store = createStore(statechange);
export default store;